import React, { useState } from 'react'

import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'

import { Button, Section, Tabs, ChallengeCard } from '../..'
import { useChallenge, useUser } from '../../../context'
import { Challenge, ChallengeStatus, ChallengeWithStatus } from '../../../types'
import { CardsContainer } from '../../Cards/styles'

export const parseDate = (value: string | undefined) => {
  if (!value) return null
  const normalized = value.trim()
  if (!normalized) return null
  const delimiter = normalized.includes('/')
    ? '/'
    : normalized.includes('-')
      ? '-'
      : null
  if (delimiter) {
    const parts = normalized.split(delimiter)
    if (parts.length === 3) {
      const [first, middle, last] = parts
      return dayjs(
        first.length === 4
          ? `${first}-${middle}-${last}`
          : `${last}-${middle}-${first}`,
      )
    }
  }
  return dayjs(normalized)
}

const ChallengesList = () => {
  const navigate = useNavigate()

  const { setOnEditionMode, onEditionMode, userRole } = useUser()
  const { challengeList } = useChallenge()
  const [filter, setFilter] = useState<ChallengeStatus>(ChallengeStatus.ACTIVE)

  const computeStatus = (challenge: Challenge) => {
    if (userRole !== 'admin' && !challenge.visibility) return null
    const start = parseDate(challenge.startDate)
    const end = parseDate(challenge.endDate)
    const today = dayjs().startOf('day')

    if (start?.isValid() && today.isBefore(start, 'day')) {
      return ChallengeStatus.UPCOMING
    }
    if (end?.isValid() && today.isAfter(end, 'day')) {
      return ChallengeStatus.ENDED
    }
    return ChallengeStatus.ACTIVE
  }

  const computedChallenges = challengeList
    .map((challenge) => ({
      ...challenge,
      status: computeStatus(challenge),
    }))
    .filter((challenge): challenge is ChallengeWithStatus =>
      Boolean(challenge.status),
    )

  const filtered = computedChallenges.filter((c) => c.status === filter)

  const handleCreateChallenge = () => {
    if (!onEditionMode) {
      setOnEditionMode(true)
      navigate(`/desafios/crear-desafio`)
    }
  }

  return (
    <Section
      title="Desafios Diga-ah!"
      childrenClass="full-space-section"
      style={{
        overflowY: 'scroll',
        paddingBottom: 0,
      }}
      ctaSection={{
        alignItems: 'center',
        cta: (
          <>
            {userRole === 'admin' && (
              <Button
                fontSize={14}
                fontWeight={600}
                onClick={handleCreateChallenge}
                label="Agregar desafio"
                className="light-blue"
              />
            )}
          </>
        ),
      }}
    >
      <Tabs
        id="status-tags"
        tabs={[
          ChallengeStatus.ACTIVE,
          ChallengeStatus.UPCOMING,
          ChallengeStatus.ENDED,
        ]}
        selectedValue={filter}
        handleTag={(tag) => setFilter(tag as ChallengeStatus)}
        isMenu={true}
      />

      <CardsContainer
        style={{
          maxHeight: `calc(100vh - ${userRole !== 'admin' ? '370' : '440'}px)`,
          flexWrap: 'wrap',
          flexDirection: 'row',
          gap: '10px',
          overflowY: 'scroll',
          paddingBottom: 20,
        }}
      >
        {filtered.map((ch) => (
          <ChallengeCard ch={ch} key={ch.id} />
        ))}
      </CardsContainer>
    </Section>
  )
}

export default ChallengesList
